import React, { useEffect, useState } from 'react'
//panel del filtro
import HeaderTitle from './Components/HeaderTitle'
import Highcharts from 'highcharts'
import HCSoldGauge from 'highcharts/modules/solid-gauge';
import { setearMiles } from "util/funciones"
import { determinateDate, determinateOperation } from '../ChartHelpers/Chart.helper';
import FiltrosFecha from './Components/FiltrosFecha';
import { getChartsData } from '../ChartHelpers/Charts.services';
import { IDatasetChart } from '../ChartHelpers/Charts.interface';
import { FiltrosOperation } from './Components';
window.Highcharts = Highcharts;
HCSoldGauge(Highcharts);
const ChartTopVolumenes = ({ updateData, identificadorEstacion }: any): React.ReactElement => {
    const [selectionDate, setSelectionDate] = useState(0)
    const [selectionOperation, setSelectionOperation] = useState(3)

    useEffect(() => {
        getData()
    }, [updateData, selectionDate, selectionOperation,identificadorEstacion])

    const getData = async (): Promise<void> => {
        const { fechaInicial, fechaFinal } = determinateDate(selectionDate)
        const { operacion, estadoMovimiento } = determinateOperation(selectionOperation)
        const body = {
            fecha_inicial: fechaInicial,
            fecha_final: fechaFinal,
            identificadorEstacion: identificadorEstacion,
            tipoMovimiento: operacion,
            tipoEstadoMovimiento: estadoMovimiento
        };
        const data = await getChartsData('VOLUMENES_VENDIDOS_TOP', body)
        construirDatos(data)
    }

    const construirDatos = (datos: any[]) => {
        const data: IDatasetChart = {
            categories: [],
            series: [],
            unidades: []
        }
        try {
            if (datos != null) {
                datos.forEach((promotor) => {
                    data.categories.push(`${promotor.descripcion}`)
                    data.unidades && data.unidades.push(`${promotor.unidad}`)
                    data.series.push(parseFloat(promotor.cantidad))
                })
            }
        } catch (error) { }
        construirGrafico(data.categories, data.series, data.unidades ?? [])
    }



    const construirGrafico = (categories: string[], series: any[], unidades: any[]): void => {
        Highcharts.chart('ventas-top-galones', {

            chart: {
                type: "bar",
            },
            title: {
                text: "",
            },
            tooltip: {
                formatter(this: Highcharts.TooltipFormatterContextObject) {
                    return `<b>${this.point.category}</b>: ${setearMiles(this.point.y)} (${unidades[this.point.index]})`;
                }
            },
            xAxis: {
                categories: categories,
            },
            yAxis: {
                min: 0,
                title: {
                    text: "TOTAL VOLUMEN",
                },
            },
            legend: {
                reversed: true,
            },
            plotOptions: {
                series: {
                    stacking: "normal",
                },
            },
            series: [{
                name: "VOLUMEN",
                data: series
            }],
        } as any);
    }


    return (
        <>
            <HeaderTitle title={'VOLUMEN DE VENTA POR PRODUCTOS'} />
            <FiltrosFecha onChange={(selection: number) => setSelectionDate(selection)} />
            <FiltrosOperation onChange={(selection: number) => setSelectionOperation(selection)} prevActive={selectionOperation} />

            <div
                id="ventas-top-galones"
                className="col-md-11 mx-auto"
            /*style={
                isShow
                    ? { marginTop: "15px", display: "block" }
                    : { display: "none" }
            }*/
            ></div>
        </>
    )
}
export default ChartTopVolumenes
